import { useState } from "react";
import AwakenTab from "./AwakenTab";
import BrightenTab from "./BrightenTab";
import CrystallizeTab from "./CrystallizeTab";

export default function ProcessSwitchTabs() {
  const [currentActive, setCurrentActive] = useState("awaken");

  const handleActive = (val) => {
    setCurrentActive((prevState) => val);
  };

  return (
    <>
      <section id="process_switch_tabs">
        <div className="container">
          <div className="switch-tab-wrapper">
            <div className="switch-tab-wrapper__buttons">
              <button
                className={`${currentActive === "awaken" ? "active" : ""}`}
                onClick={() => handleActive("awaken")}
              >
                Awaken
              </button>
              <button
                className={`${currentActive === "brighten" ? "active" : ""}`}
                onClick={() => handleActive("brighten")}
              >
                Brighten
              </button>
              <button
                className={`${currentActive === "crystallize" ? "active" : ""}`}
                onClick={() => handleActive("crystallize")}
              >
                Crystallise
              </button>
            </div>
            <div className="switch-tab-wrapper-elements">
              {currentActive === "awaken" && <AwakenTab />}
              {currentActive === "brighten" && <BrightenTab />}
              {currentActive === "crystallize" && <CrystallizeTab />}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
